import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

import ApiCache from "../libs/cache.jsx";

class Monday
{
    personal_token = '';
    
    constructor(props)
    {
        
    }
    
    setPersonalToken(personal_token = false)
    {
        this.personal_token = personal_token;
        this.usePersonalToken(true);
    }
    
    usePersonalToken(flag = false)
    {
        if( (flag === true) && this.personal_token)
        {
            monday.setToken( this.personal_token );
        }
        else
        {
            monday.setToken( null );
        }
    }
    
    async getMondaySessionToken()
    {
        try
        {
            let monday_st = await monday.get('sessionToken');

            return monday_st.data;
        }
        catch (e) {
            //console.log('EX monday query me',e);
        };

        return "";
    }

    async getMondayAppId()
    {
        try
        {
            let monday_context = await monday.get('context');

            return monday_context.data.app.id;
        }
        catch (e) {
            //console.log('EX monday query me',e);
        };

        return false;
    }
    
    parseErrors(data, query='')
    {
        //console.log(data);
        if('errors' in data)
        {
            for( var i in data.errors)
            {
                var error = data.errors[i];
                var err = null;

                if( ('extensions' in error) && ('code' in error.extensions) )
                {
                    switch(error.extensions.code)
                    {
                        case 'maxComplexityExceeded':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'complexity_exceeds';
                            throw err;
                        break;
                        case 'MINUTE_RATE_LIMIT_EXCEEDED':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'minute_rate_limit_exceeded';
                            throw err;
                        break;
                        case 'COMPLEXITY_BUDGET_EXHAUSTED':
                        case 'complexityBudgetExhausted':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'complexity_budget';
                            throw err;
                        break;
                        case 'maxConcurrencyExceeded':
                        case 'FIELD_LIMIT_EXCEEDED':
                        case 'MAX_CONCURRENCY_EXCEEDED':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'concurrency_exceeded';
                            throw err;
                        break;
                        case 'USER_ACCESS_DENIED':
                        case 'UserUnauthorizedException':
                        case 'USER_UNAUTHORIZED':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'unauthorized_exception';
                            throw err;
                        break;
                        case 'NOT_AUTHENTICATED':
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'auth_exception';
                            throw err;
                        break;
                        case 'INTERNAL_SERVER_ERROR':
                        err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'internal_server_error';
                            throw err;
                        break;
                        case 'REQUEST_TIMEOUT':
                        err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'request_timeout';
                            throw err;
                        break;
                        default:
                            err = new Error(error.message);
                            err.query = query;
                            err.data = data;
                            err.code = 'error';
                            throw err;
                    }
                }
                
                err = new Error(error.message);
                err.query = query;
                err.data = data;
                err.code = 'error';
                throw err;
            }
        }
        return false;
    }


    async apiRequest(query, loader, silent = false, reset_cache = false)
    {
        var repeat=true;

        var attempts=1;
        var data = [];

        if( ApiCache.get(query) !== null && reset_cache !== false )
        {
            //console.log( 'ApiCache RESET', query, ApiCache.get(query) );
            ApiCache.del(query);
        }

        if( ApiCache.get(query) !== null )
        {
            //console.log( 'ApiCache', query, ApiCache.get(query) );
            return ApiCache.get(query);
        }
        
        if(loader && ('current' in loader) && loader.current) loader.current.showLoader();

        while(repeat)
        {
            attempts++;

            try
            { 

                try
                {
                    data = await monday.api('query { '+query+' }');

                }
                catch(e)
                {
                    console.warn("Main exception", {e});
                    
                    this.parseErrors(e.data, query);
                    
                    throw e;
                }
                
                
                this.parseErrors(data, query);
                
                ApiCache.put(query, data);
                
                if(loader && ('current' in loader) && loader.current) loader.current.hideLoader();
                
                return data;
            }
            catch(e)
            {
                console.warn("API exception", {e});
                //console.info("Main exception", query, {e});
                
                ApiCache.del(query);
                
                if( ('code' in e) && e.code!='error')
                {
                    if( e.code === 'complexity_exceeds' )
                    {
                        console.error('Monday API query complexity_exceeds error', {e});
                        if( silent === false )
                        {
                            monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Exceeds max complexity.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 1000000,
                            });
                        }
                        
                        if(loader && ('current' in loader) && loader.current) loader.current.hideLoader();

                        throw e;
                    }
                    
                    if( e.code === 'complexity_budget' )
                    {
                        console.info('Monday API query complexity_budget, attempts: '+attempts, {e});
                        if( silent === false && (attempts===2 || attempts%10===0) ) {
                             monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 9500,
                            });
                        }
                        await new Promise(r => setTimeout(r, 1000));
                    }
                    
                    if( e.code === 'minute_rate_limit_exceeded' )
                    {
                        console.info('Monday API query minute_rate_limit_exceeded, attempts: '+attempts, {e});
                        if( silent === false && (attempts===2 || attempts%10===0) ) {
                             monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 9500,
                            });
                        }
                        await new Promise(r => setTimeout(r, 1000));
                    }
                    
                    if( e.code === 'concurrency_exceeded' )
                    {
                        console.info('Monday API query concurrency_exceeded, attempts: '+attempts, {e});
                        if( silent === false && (attempts===2 || attempts%10===0) ) {
                             monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 9500,
                            });
                        }
                        await new Promise(r => setTimeout(r, 1000));
                    }
                    
                    if( e.code === 'unauthorized_exception' )
                    {
                        console.warn('Monday API query unauthorized_exception error', {e});
                        if( silent === false )
                        {
                            monday.execute("notice", { 
                                message: "Error on Monday API request. Check you account have access level Member or Admin",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 1000000,
                            });
                        }
                        
                        if(loader && ('current' in loader) && loader.current) loader.current.hideLoader();

                        throw e;
                    }
                    
                    if( e.code === 'auth_exception' )
                    {
                        console.warn('Monday API query auth_exception error', {e});
                        if( silent === false )
                        {
                            monday.execute("notice", { 
                                message: "Error on Monday API request. Try to reload page in few minutes.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 1000000,
                            });
                        }
                        
                        if(loader && ('current' in loader) && loader.current) loader.current.hideLoader();

                        throw e;
                    }
                    
                    if( e.code === 'internal_server_error' )
                    {
                        console.info('Monday API query internal_server_error, attempts: '+attempts, {e});
                        if( silent === false && (attempts===2 || attempts%10===0) ) {
                             monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 9500,
                            });
                        }
                        await new Promise(r => setTimeout(r, 1000));
                    }
                    
                    if( e.code === 'request_timeout' )
                    {
                        console.info('Monday API query request_timeout, attempts: '+attempts, {e});
                        if( silent === false && (attempts===2 || attempts%10===0) ) {
                             monday.execute("notice", { 
                                message: "Error on Monday API request with API Limits. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 9500,
                            });
                        }
                        await new Promise(r => setTimeout(r, 1000));
                    }

                }
                else
                {
                    console.warn('Monday API query error: unknow', {e});
                    //if(loader.current) loader.current.hideLoader();
                    
                    if( silent === false && (attempts===2 || attempts%10===0) ) {
                        monday.execute("notice", { 
                           message: "Error on Monday API request. Attempt "+Math.ceil(attempts/10)+" of 30. Repeat in 10 sec.",
                           type: "error", // or "error" (red), or "info" (blue)
                           timeout: 9500,
                       });
                    }
                    await new Promise(r => setTimeout(r, 1000));
                }
            }

            if(attempts>=300)
            {
                repeat = false;

                if( silent === false )
                {
                    monday.execute("notice", { 
                        message: "Error on Monday API request. Try to reload page in few minutes.",
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 1000000,
                    });
                }
                
                if(loader && ('current' in loader) && loader.current) loader.current.hideLoader();
                
                console.warn('Monday API query error Attempts limit: '+attempts, {e}, query);
                throw new Error('Monday API query error Attempts limit: '+attempts+'. Query: '+query+'.');
            }
        }
    }


    async apiRequestAllPages(query, dataName='items', loader, pause = false, reset_cache = false)
    {
        var data = [];
        var page = 1;
        var pageData = {};
        var pageQuery = "";
        var flag = true;

        if(loader && ('current' in loader) && loader.current!=null) loader.current.showLoader();

        while(flag)
        {
            pageQuery = query.replace('%page%', page);

            pageData = await this.apiRequest(pageQuery, loader, pause, reset_cache);

            //console.log("apiRequestAllPages", pageQuery, pageData);

            if( !(dataName in pageData['data']) || !(Array.isArray(pageData['data'][dataName])) || pageData['data'][dataName].length == 0 )
            {
                flag = false;
            }
            else
            {
                data.push(pageData);
                page++;

                if(pause !== false)
                {
                    //console.log("apiRequestAllPages Pause");
                    await new Promise(r => setTimeout(r, 300));
                }
            }
        }

        if(loader && ('current' in loader) && loader.current!=null) loader.current.hideLoader();

        return data;

    }


    async getMondayAccountSlug(loader)
    {
        let data = null;

        data = await this.apiRequest('account { slug }', loader);

        if( ('account' in data.data) && ('slug' in data.data.account) )
        {
            return data.data.account.slug;
        }

        return null;
    }


    async getMondayAccountId(loader)
    {
        let data = null;

        data = await this.apiRequest('account { id }', loader);

        if( ('account' in data.data) && ('id' in data.data.account) )
        {
            return data.data.account.id;
        }

        return null;
    }




    async checkMondaySubscription(loader)
    {
        var plans = {
            'upto_10_free': 10,
            'upto_50': 50,
            'upto_100': 100,
            'upto_250': 250,
            'upto_750': 750,
            'upto_2500': 2500,
            'unlimited': 0,
            
            'V2_upto_10_free': 10,
            'V2_upto_30': 30,
            'V2_upto_50': 50,
            'V2_upto_100': 100,
            'V2_upto_175': 175,
            'V2_upto_250': 250,
            'V2_upto_750': 750,
            'V2_upto_1500': 1500,
            'V2_upto_2500': 2500,
            'V2_unlimited': 0,
            
            'V3_upto_10_free': 10,
            'V3_upto_30': 30,
            'V3_upto_50': 50,
            'V3_upto_75': 75,
            'V3_upto_100': 100,
            'V3_upto_150': 150,
            'V3_upto_200': 200,
            'V3_upto_250': 250,
            'V3_upto_300': 300,
            'V3_upto_350': 350,
            'V3_upto_400': 400,
            'V3_upto_450': 450,
            'V3_upto_500': 500,
            'V3_upto_600': 600,
            'V3_upto_750': 750,
            'V3_upto_1000': 1000,
            'V3_upto_1500': 1500,
            'V3_upto_2000': 2000,
            'V3_upto_2500': 2500,
            'V3_unlimited': 0
        } 


        let data = null;

        //subscription ok if the current app tableau
        //if( config.app_core == 'monday_tableau' )
        //{
        //    console.log('checkMondaySubscription', config.app_core);
        //    return true;
        //}
        //end

        this.usePersonalToken(false);
        
        data = await this.apiRequest('account { id, plan { tier, period, max_users } }, app_subscription { plan_id, is_trial, days_left, max_units}', loader);
        console.log('checkMondaySubscription data', data.data);
        
        this.usePersonalToken(true);

        //subscription ok if the current account  is ours
        if( ('account' in data.data) && ('id' in data.data.account) && ( ["11629351","14290151","13451466","30115488"].includes(data.data.account.id) ) )
        {
            return true;
        }
        //end

        if( ('app_subscription' in data.data) && (data.data.app_subscription.length==1) )
        {
            var account_users = ( ('plan' in data.data.account) && (data.data.account.plan !=null ) && ('max_users' in data.data.account.plan) )? data.data.account.plan.max_users : 0;
            
            account_users = account_users == null ? 0 : account_users;

            var subscription_users = data.data.app_subscription[0].max_units == null ? 0 : data.data.app_subscription[0].max_units;

            if(
                (subscription_users == 0)
                ||
                (subscription_users != 0 && (subscription_users >= account_users) )
            ) return true;
        }

        return false;
    }


    async getMondayUser(loader)
    {
        let monday_user = await this.apiRequest('me { id, name, title, email, enabled, is_admin, is_guest, is_pending, is_verified, is_view_only,  }, account { id }', loader);

        if(monday_user && ('data' in monday_user) && ('me' in monday_user.data))
        {
            //console.log( "me:", monday_user);
            monday_user.data.me['account_id'] = monday_user.data.account.id;
            return monday_user.data.me;
        }

        return {};
    }



    addDefaultsFields(fields, table)
    {
        if(config && ('feed' in config) && ('tables' in config.feed) && (table in config.feed.tables) && ('default_fields' in config.feed.tables[table]) )
        {
            Object.keys(config.feed.tables[table].default_fields).forEach((key) => {
                var field = config.feed.tables[table].default_fields[key];
                var item = {'name': key, 'type':'default_fields', 'id':'id' };

                item.notice = ( ('notice' in field) ? field.notice : {} );

                fields.push( item );
            });
        }
        return fields;
    }


    addFields(fields, table)
    {
        if(config && ('feed' in config) && ('tables' in config.feed) && (table in config.feed.tables) && ('fields' in config.feed.tables[table]) )
        {
            Object.keys(config.feed.tables[table].fields).forEach((key) => {
                var field = config.feed.tables[table].fields[key];
                var item = {'name': key, 'type': 'fields', 'id':'id' };

                item.notice = ( ('notice' in field) ? field.notice : {} );

                fields.push( item );
            });
        }
        return fields;
    }


    isSupportedType(type)
    {
        var supported_types = [];
        if(config && (`feed` in config) && (`fields` in config.feed))
        {
            supported_types = Object.keys(config.feed.fields);
            return supported_types.includes(type);
        }

        return false;
    }

    aggregateItemFieldsList(fields, boards)
    {
        boards.forEach((board) => {

            if(`columns` in board)
            {
                board.columns.forEach((column) => {

                    if(this.isSupportedType(column.type) != true) return;

                    var field = { 'name': column.title, 'type': column.type, 'id': column.id }; //, 'board_id': board.id

                    if( fields.filter( el => { return (el.name==field.name) && (el.type==field.type) && (el.id==field.id) } ).length == 0)
                    {
                        if(config && ('feed' in config) && ('fields' in config.feed) && (field.type in config.feed.fields) )
                        {
                            //console.log('field', config.feed.fields[field.type]);
                            field.notice = ( ('notice' in config.feed.fields[field.type][0]) ? config.feed.fields[field.type][0].notice : {} );
                        }
                        fields.push( field );
                    }

                    //save bard_id and workspace_id for each field(by name, type, id)
                    fields = fields.map(el => { 
                        var workspace = board.workspace;

                        if(workspace == null) workspace = {id:'0','name':'Main workspace','state':'active'};
                        if( ('id' in workspace) && (workspace.id == null)) workspace.id = 0

                        workspace.id = workspace.id.toString();

                        if( (el.name==field.name) && (el.type==field.type) && (el.id==field.id) )
                        {
                            if( !Array.isArray(el.workspaces) ) el.workspaces = [];
                            if( !Array.isArray(el.boards) ) el.boards = [];

                            if(! el.workspaces.map((item) => { return item.id; }).includes(workspace.id) ) el.workspaces.push(workspace);
                            if(! el.boards.map((item) => { return item.id; }).includes(board.id) )  el.boards.push(board);
                        }

                        return el;
                    });
                    //end

                });

            }
        });

        return fields;
    }


    async getItemsFields(loader, pause = false, reset_cache = false)
    {
        var boards = [];
        var data = await this.apiRequestAllPages('complexity { before after query }, boards(limit:500, page:%page%, state: all) { id workspace { id name state } name columns { id title type settings_str } type state updated_at }', 'boards', loader, pause, reset_cache);

        var present_date = new Date();

        for(let i of data.keys())
        {
            for(let j of data[i].data.boards.keys())
            {
                var board = data[i].data.boards[j];

                //filter by type
                if( !(['board'].includes( board.type )) ) continue;

                //filer deleted boards with 300 days
                var dt = new Date( board.updated_at );
                var Difference_In_Time = present_date.getTime() - dt.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                if( (['deleted'].includes( board.state )) && Difference_In_Days>30 ) 
                {
                    continue;
                }

                boards.push(board);
            }
        }

        var fields = [];

        fields = this.addDefaultsFields(fields, 'items');
        fields = this.addFields(fields, 'items');
        fields = this.aggregateItemFieldsList(fields, boards);

        return fields;
    }


    async getSubItemsFields(loader, pause = false, reset_cache = false)
    {
        var boards = [];
        var sub_boards_ids = [];
        var parent_boards = [];
        var data = await this.apiRequestAllPages('complexity { before after query }, boards(limit:500, page:%page%, state: all) { id workspace { id name state } name columns { id title type settings_str } type state updated_at }', 'boards', loader, pause, reset_cache);

        var present_date = new Date();

        for(let i of data.keys())
        {
            for(let j of data[i].data.boards.keys())
            {
                var board = data[i].data.boards[j];

                //filer deleted boards with 300 days
                var dt = new Date( board.updated_at );
                var Difference_In_Time = present_date.getTime() - dt.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                if( (['deleted'].includes( board.state )) && Difference_In_Days>30 ) 
                {
                    continue;
                }
                
                if( (['board'].includes( board.type )) )
                {
                    parent_boards.push(board);
                }
                
                //filter by type
                if( !(['sub_items_board'].includes( board.type )) ) continue;

                boards.push(board);
                sub_boards_ids.push(board.id);
            }
        }
        
        
        
        //search parent board id for each sub board
        boards.map( function (board) {
            var sub_board_id = board.id;
            
            var parent_board = parent_boards.filter( function(parent_board) { 
                
                if(!Array.isArray(parent_board.columns)) return false;
                
                var columns = parent_board.columns.filter(function(column) { return column.type === 'subtasks'; });
                
                if( columns.length>0 && ('settings_str' in columns[0]) )
                {
                    var column = JSON.parse(columns[0].settings_str);
                    if( ('boardIds' in column) && Array.isArray(column.boardIds) && column.boardIds.length>0 && column.boardIds[0] == sub_board_id)
                    {
                        return true;
                    }
                }
                
                return false;
            } );
            
            if( parent_board.length>0)
            {
                board.parent_board = {'id':parent_board[0].id,'state':parent_board[0].state};
            }
            
            return board;
        });
        
        boards = boards.filter(function(board) { return ('parent_board' in board); });
        
        /*
        if(sub_boards_ids.length>0)
        {
            const chunkSize = 10;
            for (let chunk_i = 0; chunk_i < sub_boards_ids.length; chunk_i += chunkSize)
            {
                const chunk = sub_boards_ids.slice(chunk_i, chunk_i + chunkSize);

                var query = 'complexity { before after query }, boards(limit:10, page:%page%, state: all, ids: ['+(chunk.join(','))+']) { id, items_page(limit:100) { items { parent_item{ board{ id state } } } } }';
                var data = await this.apiRequestAllPages(query, 'boards', loader, pause, pause);

                for(let i of data.keys())
                {
                    for(let j of data[i].data.boards.keys())
                    {
                        var subboard = data[i].data.boards[j];
                        var filtered_items = subboard.items_page.items.filter( function(item) { return (('parent_item' in item) && (item.parent_item !=null)); } );
                        if(filtered_items.length>0)
                        {
                            boards.map( function (board) {
                                if(board.id == subboard.id)
                                {
                                    board.parent_board = filtered_items[0].parent_item.board;
                                }

                                return board;
                            });
                        }
                    }
                }
            }
        }
        */
        //end

        var fields = [];

        fields = this.addDefaultsFields(fields, 'subitems-items');
        fields = this.addFields(fields, 'subitems-items');
        fields = this.aggregateItemFieldsList(fields, boards);

        return fields;
    }

    async getActivityLogsFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'activity-logs');
        fields = this.addFields(fields, 'activity-logs');

        return fields;
    }

    async getUsersFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'users');
        fields = this.addFields(fields, 'users');

        //console.log( "getUsersFields", fields);
        return fields;
    }


    async getTeamsFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'teams');
        fields = this.addFields(fields, 'teams');

        return fields;
    }


    async getBoardsFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'boards');
        fields = this.addFields(fields, 'boards');

        return fields;
    }

    async getFoldersFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'folders');
        fields = this.addFields(fields, 'folders');

        return fields;
    }



    async getGroupsFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'groups');
        fields = this.addFields(fields, 'groups');

        return fields;
    }


    async getWorkspacesFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'workspaces');
        fields = this.addFields(fields, 'workspaces');

        return fields;
    }


    async getTagsFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'tags');
        fields = this.addFields(fields, 'tags');

        return fields;
    }


    async getUpdatesFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'updates');
        fields = this.addFields(fields, 'updates');

        return fields;
    }
    
    
    async getTracketFields()
    {
        var fields = [];

        fields = this.addDefaultsFields(fields, 'tracket');
        fields = this.addFields(fields, 'tracket');

        return fields;
    }



    async getWorkspaces(loader, states = ['active'])
    {
        var all_workspaces = [];
        var default_workspace = false;
        
        var data = await this.apiRequestAllPages('complexity { before after query }, workspaces(limit:200, page:%page%, state: all) { id name state is_default_workspace }', 'workspaces', loader);

        for(let i of data.keys())
        {
            for(let j of data[i].data.workspaces.keys())
            {
                if( !(states.includes( data[i].data.workspaces[j].state )) ) continue;
                
                if(data[i].data.workspaces[j]['is_default_workspace'] == true)
                {
                    default_workspace = true;
                }
                
                all_workspaces.push(data[i].data.workspaces[j]);
            }
        }

        var workspaces = [];
        
        if(!default_workspace)
        {
            var item = { 
                'id': "0",
                'name': 'Main Workspace',
                'state': 'active'
            };

            workspaces.push( item );
        }

        all_workspaces.forEach((workspace) => {
            var item = { 
                'id': workspace.id.toString(),
                'name': workspace.name,
                'state': workspace.state
            };
            workspaces.push( item );
        });

        workspaces.sort(function (a, b) {
            if(typeof a.name.localeCompare == 'function')
            {
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            }
            else
            {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
            }
            return 0;
        });

        return workspaces;
    }



    async getBoards(loader, states = ['active'])
    {
        var boards = [];
        var data = await this.apiRequestAllPages('complexity { before after query }, boards(limit:100, page:%page%, state: all) { id name workspace_id type state updated_at }', 'boards', loader);

        var present_date = new Date();

        for(let i of data.keys())
        {
            for(let j of data[i].data.boards.keys())
            {
                var board = data[i].data.boards[j];

                //filter by type
                if( !(['board'].includes( board.type )) ) continue;
                if( !(states.includes( board.state )) ) continue;

                //filer deleted boards with 300 days
                var dt = new Date( board.updated_at );
                var Difference_In_Time = present_date.getTime() - dt.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                if( (['deleted'].includes( board.state )) && Difference_In_Days>30 ) 
                {
                    continue;
                }

                boards.push(board);
            }
        }

        var dataBoards = [];

        boards.forEach((board) => {
            if( ('id' in board) && ('name' in board) )
            {
                var item = { 
                    'id': board.id, 
                    'name': board.name, 
                    'workspace_id': board.workspace_id==null?'0':board.workspace_id.toString(),
                    'state': board.state
                };
                dataBoards.push( item );
            }
        });

        dataBoards.sort(function (a, b) {
            if(typeof a.name.localeCompare == 'function')
            {
                return a.name.localeCompare(b.name, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            }
            else
            {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
            }
            return 0;
        });

        return dataBoards;
    }


    async getUsers(loader)
    {
        var users = {};

        var data = await this.apiRequestAllPages('complexity { before after query }, users(limit:100, page:%page%, non_active: false) { id name email enabled }', 'users', loader);

        for(let i of data.keys())
        {
            for(let j of data[i].data.users.keys())
            {
                var user = data[i].data.users[j];
                users[user.id]=user;
            }
        }

        var data = await this.apiRequestAllPages('complexity { before after query }, users(limit:100, page:%page%, non_active: true) { id name email enabled }', 'users', loader);
        for(let i of data.keys())
        {
            for(let j of data[i].data.users.keys())
            {
                var user = data[i].data.users[j];
                users[user.id]=user;
            }
        }

        //console.log("users", users);

        return users;
    }

    async getTeams(loader)
    {
        var teams = {};

        var data = await this.apiRequest('complexity { before after query }, teams { id, name }', loader);
        //console.log("getTeams", data);

        if( ('data' in data) && ('teams' in data.data) )
        {
            for(let i of data.data.teams.keys())
            {
                var team = data.data.teams[i];
                teams[team.id]=team;
            }
        }

        //console.log("teams", teams);

        return teams;
    }
}

export default new Monday();